export default __webpack_public_path__ + "static/media/SGS-logo.34aec4de.png";